import { SelectorProps } from './BaseSelector';
import { Box, colors, ListItemButton, ListItemIcon, ListItemText } from '@mui/material';
import { ExportProgress } from './ExportProgress';
import { BatchExport } from '../../../../../integrations/exports/models/BatchExport';

export type BatchExportSelectorProps = SelectorProps & {
  exportJob: BatchExport | null;
  onCancel: () => void;
};

export const BatchExportSelector = ({
  selected,
  disabled,
  loading,
  disabledReason,
  title,
  description,
  onSelected,
  exportJob,
  onCancel,
  icon,
}: BatchExportSelectorProps) => {
  const isDisabled = disabled || (loading ?? false);
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        backgroundColor: selected ? 'inherit' : 'white',
        borderRadius: '4px',
        mb: 2,
        border: '1px solid',
        opacity: isDisabled ? 0.5 : 1,
        pointerEvents: isDisabled ? 'none' : 'auto',
        cursor: isDisabled ? 'not-allowed' : 'pointer',
        borderColor: isDisabled ? 'grey.300' : selected ? colors.blue[400] : 'grey.300',
        '&.Mui-selected': { borderColor: colors.blue[400] },
      }}
    >
      <ListItemButton
        component="button"
        data-role="export-format-selector"
        selected={selected}
        onClick={onSelected}
        alignItems="flex-start"
        sx={{
          py: 1.5,
        }}
      >
        <ListItemIcon>{icon}</ListItemIcon>
        <ListItemText
          primary={title}
          secondary={disabled && disabledReason ? disabledReason : description}
          primaryTypographyProps={{ component: 'span', fontWeight: '500', fontSize: '1rem', mb: 1.25 }}
          secondaryTypographyProps={{ color: 'text.secondary' }}
        />
      </ListItemButton>
      {exportJob && <ExportProgress exportJob={exportJob} onCancel={onCancel} />}
    </Box>
  );
};
